import { render, staticRenderFns } from "./ImportTrucks.vue?vue&type=template&id=617458b8&scoped=true"
import script from "./ImportTrucks.vue?vue&type=script&lang=ts"
export * from "./ImportTrucks.vue?vue&type=script&lang=ts"
import style0 from "./ImportTrucks.vue?vue&type=style&index=0&id=617458b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617458b8",
  null
  
)

export default component.exports